export const getRandomTime = (from: number, to: number) => {
  return Math.floor(Math.random() * (to - from + 1)) + from
}

/**
 * Generates a random time debounce in the provided range of miliseconds
 * @param from
 * @param to
 */
export const randomDebounce = (
  from: number,
  to: number,
  callback: () => unknown
) => {
  const randTime = getRandomTime(from, to)

  return setTimeout(() => {
    callback()
  }, randTime)
}
